var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "total-transaction-pannel" }, [
    _c(
      "div",
      { attrs: { id: "tab-content" } },
      [
        _c(
          "div",
          { staticClass: "text-title" },
          [
            _vm._v(" " + _vm._s(_vm.$t("dashboard.today")) + " "),
            _c("el-tooltip", { attrs: { placement: "bottom" } }, [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("tips.current_time_zone")))]),
              ]),
              _c(
                "span",
                [
                  _c("svg-icon", {
                    staticStyle: {
                      width: "22px",
                      color: "#0058CF",
                      cursor: "pointer",
                    },
                    attrs: { "icon-class": "icon-font-warning" },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "first",
                expression: "activeName === 'first' ",
              },
            ],
            staticClass: "panel-group",
            attrs: { gutter: 20 },
          },
          [
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_count")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [_vm._v(_vm._s(_vm.overviewData.total_count || 0))]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_amount")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.total_amount
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("dashboard.commission")) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.total_commission
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "second",
                expression: "activeName === 'second' ",
              },
            ],
            staticClass: "panel-group",
            attrs: { gutter: 20 },
          },
          [
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_count")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [_vm._v(_vm._s(_vm.overviewData.payment_count || 0))]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_amount")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.payment_total_amount
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("dashboard.commission")) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.payment_commission
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "third",
                expression: "activeName === 'third' ",
              },
            ],
            staticClass: "panel-group",
            attrs: { gutter: 20 },
          },
          [
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_count")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [_vm._v(_vm._s(_vm.overviewData.payout_count || 0))]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("dashboard.transaction_amount")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.payout_total_amount
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "el-col",
              { staticClass: "card-panel-col", attrs: { span: 8 } },
              [
                _c("div", { staticClass: "card-panel" }, [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("dashboard.commission")) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-panel-num color-main-linear-blue" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.payout_commission
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { attrs: { id: "tab-container" } }, [
      _c(
        "div",
        {
          staticClass: "tab-header",
          class: { active: _vm.activeName === "first" },
          on: {
            click: function ($event) {
              _vm.activeName = "first"
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dashboard.total_transaction")))]
      ),
      _c(
        "div",
        {
          staticClass: "tab-header",
          class: { active: _vm.activeName === "second" },
          on: {
            click: function ($event) {
              _vm.activeName = "second"
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dashboard.payin")))]
      ),
      _c(
        "div",
        {
          staticClass: "tab-header",
          class: { active: _vm.activeName === "third" },
          on: {
            click: function ($event) {
              _vm.activeName = "third"
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dashboard.payout")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }